import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { Box, Icon, Modal, Message, Delete, Columns, Column } from 'Components/common/bulma'
import Table from 'Components/common/table'
import { getList, deleteOrder } from 'Modules/loanOrders/paymentAmortization'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons'
import { Trans } from '@lingui/macro'
import { paymentAmortizationCols } from './data'
import { Button } from 'Components/common/bulma'
import { addNotification } from 'Modules/principal'


export class ListaContainer extends Component {
  state = {
    showModal: false,
    wallet: {},
  }

  onEdit = ({id}) => {
    const { push } = this.props;
    push(`/ordenes-prestamo/amortizacion-pago/${id}`);
  }

  toggleModal = (wallet) => {
    this.setState(state => ({
      showModal: !state.showModal,
      wallet,
    }))
  }

  deleteOrder = () => {
    this.props.deleteOrder(this.state.wallet.id)
      .then(() => {
        this.props.addNotification({
          type: 'success',
          message: 'La órden de prestamos se eliminó correctamente'
        })
        this.setState({
          showModal: false,
        })
        this.props.getList()
      })
      .catch(({ response: { data } }) => {
        this.props.addNotification({
          type: 'danger',
          message: JSON.stringify(data.message)
        })

        this.setState({
          showModal: false
        })
      })
  }

  customColAccions = (row) => (
    <Fragment >
      <Button small className="margin-left-xs" primary outlined onClick={() => this.onEdit(row)}>
        <Icon>
          <FontAwesomeIcon icon={faEdit} />
        </Icon>
      </Button>
      <Button
        small
        disabled={row.estatusId !== '1'}
        className="margin-left-xs" danger outlined onClick={() => this.toggleModal(row)}>
        <Icon>
          <FontAwesomeIcon icon={faTrash} />
        </Icon>
      </Button>
    </Fragment>
  )

  render() {
    const { list } = this.props

    return (
      <Box>
        <Modal isActive={this.state.showModal}>
          <Message danger>
            <Message.Header>
              <p>Eliminar orden de prestamo (pago de prestamos)</p>
              <Delete onClick={this.toggleModal} />
            </Message.Header>
            <Message.Body className="has-text-centered">
              ¿Esta seguro de querer la orden de prestamo (pago de prestamos)?
            <br />
              <strong>{this.state.wallet.id}</strong>
              <div className="margin-top-lg">
                <Button danger onClick={this.deleteOrder}>Eliminar</Button>
                <Button default className="margin-left-sm" onClick={this.toggleModal}>
                  Cancelar
              </Button>
              </div>
            </Message.Body>
          </Message>
        </Modal>
        <Columns>
          <Column>
            <Link className="button is-success is-outlined is-pulled-right" to="/ordenes-prestamo/amortizacion-pago/nuevo">
              <Icon>
                <FontAwesomeIcon icon={faPlus} />
              </Icon>
              <Trans render="span">Agregar Orden de Prestamos (pago de prestamos)</Trans>
            </Link>
          </Column>
        </Columns>
        <Columns>
          <Column>
            <Table
              filterable
              colsetup={paymentAmortizationCols}
              coldata={list}
              tableClassName='table is-striped is-hoverable is-fullwidth'
              emptyTableMarkUp={<span>No se encontraron registros</span>}
              customCol={{
                customColName: 'actions',
                renderFunc: this.customColAccions
              }}
              refresh={this.props.getList}
            />
          </Column>
        </Columns>
      </Box>
    )
  }
}

const mapStateToProps = ({ loanOrders }) => ({
  list: loanOrders.paymentAmortization.list,
  isFetching: loanOrders.paymentAmortization.isFetchingPaymentAmortization
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getList,
  push,
  deleteOrder,
  addNotification,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListaContainer)
